import { typeBonuses } from "./bonus"
import { queryCustomerBonusAgreements } from "./queries/queryCustomerBonusAgreements"

const bonusSchema = {
  types: [typeBonuses],
  resolvers: {
    Query: {
      ...queryCustomerBonusAgreements,
    },
    Mutation: {},
  },
}

export default bonusSchema
